// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__2Qh+R","LivrairieLogoText":"Logo_LivrairieLogoText__D05yb","LivrairieLogo":"Logo_LivrairieLogo__Fakpe"};